import { lazy } from "react";
import Loadable from "app/components/Loadable";

const OnboardingList = Loadable(lazy(() => import("./DoctorOnboardingList")));
const OnboardingLanding = Loadable(
  lazy(() => import("./DoctorOnboardingLanding")),
);
const DoctorSearch = Loadable(lazy(() => import("./DoctorSearch")));
const DoctorUserLinkReconciliationPage = Loadable(
  lazy(() => import("./DoctorUserLinkReconciliationPage")),
);

const OnboardingRoutes = [
  { path: "/doctors/onboard/:mode/:id", element: <OnboardingLanding /> },
  { path: "/doctors/onboard/reconciliation", element: <DoctorUserLinkReconciliationPage /> },
  { path: "/doctors/onboard", element: <OnboardingList /> },
  { path: "/doctors/search", element: <DoctorSearch /> },
];

export default OnboardingRoutes;
